import React, { useEffect, useRef } from 'react';
import './CoupangAd.css';

const CoupangAd = ({ type = 'dynamic', category = 'kids' }) => {
  const adRef = useRef(null);

  // 쿠팡 파트너스 다이나믹 배너 설정 (실제 제공받은 코드 사용)
  const getDynamicBannerConfig = () => {
    switch (category) {
      case 'kids':
        return {
          id: 926857,
          template: 'carousel',
          trackingCode: 'AF8550529',
          width: '680',
          height: '140',
          subId: 'acornbank_kids'
        };
      case 'family':
        return {
          id: 926857,
          template: 'carousel',
          trackingCode: 'AF8550529',
          width: '680',
          height: '140',
          subId: 'acornbank_family'
        };
      default:
        return {
          id: 926857,
          template: 'carousel',
          trackingCode: 'AF8550529',
          width: '680',
          height: '140',
          subId: 'acornbank_default'
        };
    }
  };

  useEffect(() => {
    // 부모 화면에서만 쿠팡 스크립트 로드
    if (window.location.pathname.startsWith('/parent/') && adRef.current) {
      const config = getDynamicBannerConfig();

      // 기존 스크립트가 이미 로드되었는지 확인
      if (!document.querySelector('script[src="https://ads-partners.coupang.com/g.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://ads-partners.coupang.com/g.js';
        script.async = true;
        script.onload = () => {
          renderCoupangAd(config);
        };
        document.head.appendChild(script);
      } else {
        // 스크립트가 이미 로드된 경우 바로 렌더링
        renderCoupangAd(config);
      }
    }
  }, [category]);

  const renderCoupangAd = (config) => {
    if (window.PartnersCoupang && window.PartnersCoupang.G && adRef.current) {
      // 기존 광고 제거
      adRef.current.innerHTML = '';

      // 임시 div 생성 (광고가 여기에 먼저 생성됨)
      const tempDiv = document.createElement('div');
      document.body.appendChild(tempDiv);

      // 새 광고 생성
      try {
        new window.PartnersCoupang.G({
          id: config.id,
          template: config.template,
          trackingCode: config.trackingCode,
          width: config.width,
          height: config.height,
          subId: config.subId,
          tsource: ''
        });

        // 생성된 iframe을 찾아서 우리 컨테이너로 이동
        setTimeout(() => {
          const iframes = document.querySelectorAll('iframe[src*="ads-partners.coupang.com"]');
          const latestIframe = iframes[iframes.length - 1]; // 가장 최근에 생성된 iframe

          if (latestIframe && adRef.current) {
            // 로딩 메시지 제거
            adRef.current.innerHTML = '';
            // iframe을 우리 컨테이너로 이동
            adRef.current.appendChild(latestIframe);
          }

          // 임시 div 제거
          if (tempDiv.parentNode) {
            tempDiv.parentNode.removeChild(tempDiv);
          }
        }, 1000);

      } catch (error) {
        console.error('쿠팡 광고 렌더링 오류:', error);
        if (tempDiv.parentNode) {
          tempDiv.parentNode.removeChild(tempDiv);
        }
      }
    }
  };

  // 부모 화면이 아닌 경우 광고 표시하지 않음
  if (!window.location.pathname.startsWith('/parent/')) {
    return null;
  }

  if (type === 'dynamic') {
    return (
      <div className="coupang-dynamic-banner">
        <div className="ad-header">
          <span className="ad-label">광고</span>
          <span className="ad-title">추천 상품</span>
        </div>
        <div ref={adRef} className="dynamic-ad-container">
          {/* 쿠팡 다이나믹 배너가 여기에 렌더링됩니다 */}
          <div className="ad-loading">
            <p>광고를 불러오는 중...</p>
          </div>
        </div>
        <div className="ad-footer">
          <small>쿠팡 파트너스 활동을 통해 일정액의 수수료를 제공받을 수 있습니다.</small>
        </div>
      </div>
    );
  }

  // iframe 버전 (더 안정적)
  if (type === 'iframe') {
    const config = getDynamicBannerConfig();
    const iframeSrc = `https://ads-partners.coupang.com/widgets.html?id=${config.id}&template=${config.template}&trackingCode=${config.trackingCode}&subId=${config.subId}&width=${config.width}&height=${config.height}&tsource=`;

    return (
      <div className="coupang-dynamic-banner">
        <div className="ad-header">
          <span className="ad-label">광고</span>
          <span className="ad-title">추천 상품</span>
        </div>
        <div className="dynamic-ad-container">
          <iframe
            src={iframeSrc}
            width={config.width}
            height={config.height}
            frameBorder="0"
            scrolling="no"
            referrerPolicy="unsafe-url"
            browsingTopics
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </div>
        <div className="ad-footer">
          <small>쿠팡 파트너스 활동을 통해 일정액의 수수료를 제공받을 수 있습니다.</small>
        </div>
      </div>
    );
  }

  // 사이드 배너 타입
  return (
    <div className="coupang-side-banner">
      <div className="ad-header">
        <span className="ad-label">광고</span>
      </div>
      <div ref={adRef} className="side-ad-container">
        {/* 쿠팡 사이드 배너가 여기에 렌더링됩니다 */}
        <div className="ad-loading">
          <p>광고 로딩중...</p>
        </div>
      </div>
      <div className="ad-footer">
        <small>파트너스 수수료 지급</small>
      </div>
    </div>
  );
};

export default CoupangAd;